type BrandProps = {
  compact?: boolean;
  markOnly?: boolean;
  reverse?: boolean;
};

export const BrandMark = ({ reverse = false }: { reverse?: boolean }) => (
  <svg className="as-brand-mark" viewBox="0 0 64 64" role="img" aria-label="Auto Sens">
    <title>Auto Sens</title>
    <text x="5" y="30" fill={reverse ? '#F2EFE6' : '#101B2B'} fontFamily="Archivo, Arial, sans-serif" fontSize="30" fontWeight="800">A</text>
    <path d="M42 5 21 59" stroke="#D8FF52" strokeWidth="4" />
    <text x="34" y="57" fill={reverse ? '#F2EFE6' : '#101B2B'} fontFamily="Archivo, Arial, sans-serif" fontSize="30" fontWeight="800">S</text>
  </svg>
);

export const Brand = ({ compact = false, markOnly = false, reverse = false }: BrandProps) => (
  <span className={`as-brand${compact ? ' as-brand-compact' : ''}${markOnly ? ' as-brand-mark-only' : ''}`}>
    <BrandMark reverse={reverse} />
    {!markOnly && <span className="as-wordmark">Auto Sens</span>}
  </span>
);
